import { isApplePayAllowedInOrder } from '../../selectors/order';
import { CheckoutState } from '../../state';
import { isTLDWithApplePayEnabled } from './isTLDWithApplePayEnabled';
import { getIsApplePaySupported } from './pureSelectors';

export const isApplePayInCheckoutStepEnabled = (state: CheckoutState) =>
    isApplePayAllowedInOrder(state) &&
    isTLDWithApplePayEnabled(state) &&
    getIsApplePaySupported(state);
